import { render, staticRenderFns } from "./PrincipalView.vue?vue&type=template&id=12fee48f&scoped=true"
import script from "./PrincipalView.vue?vue&type=script&lang=js"
export * from "./PrincipalView.vue?vue&type=script&lang=js"
import style0 from "./PrincipalView.vue?vue&type=style&index=0&id=12fee48f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fee48f",
  null
  
)

export default component.exports